import type React from 'react'
import type { JSX } from 'react'
import type { CoversList } from 'blocks/Cards/Card.h'

import { useCallback, useState } from 'react'
import { ImagePoster } from 'atoms/ImagePoster'
import { OverlayLayout, OverlayLayoutColors } from 'atoms/OverlayLayout'
import { usePoster } from 'utils/hooks'
import { GridContainerSC, PosterContainerSC } from './GridContainer.styled'

export interface IGridContainerProps {
  children?: React.ReactNode
  title?: string
  poster?: CoversList
  posterUrl?: string | null
  overlayEnabled?: boolean
  overlayHeight?: string
  overlayVerticalColor?: OverlayLayoutColors
  overlayGradient?: OverlayLayoutColors
}

export const GridContainer = ({
  children,
  title = '',
  poster,
  posterUrl,
  overlayEnabled = true,
  overlayHeight = '100%',
  overlayVerticalColor = OverlayLayoutColors.BACKGROUND_VERTICAL_OVERLAY,
  overlayGradient,
}: IGridContainerProps): JSX.Element => {
  const Poster = usePoster(title, poster)

  const [isPosterLoaded, setIsPosterLoaded] = useState<boolean>(true)

  const handlePosterLoading = useCallback(() => {
    setIsPosterLoaded(true)
  }, [])

  const handlePosterError = useCallback(() => {
    setIsPosterLoaded(false)
  }, [])

  return (
    <GridContainerSC>
      <PosterContainerSC>
        {posterUrl && isPosterLoaded ? (
          <ImagePoster
            posterUrl={posterUrl}
            handleLoading={handlePosterLoading}
            handleError={handlePosterError}
            lazy={false}
          />
        ) : (
          <Poster />
        )}
        {overlayEnabled && (
          <OverlayLayout
            overlayEnabled={overlayEnabled}
            overlayHeight={overlayHeight}
            overlayVerticalColor={overlayGradient ?? overlayVerticalColor}
          />
        )}
      </PosterContainerSC>
      {children}
    </GridContainerSC>
  )
}
